import styled from 'styled-components'

interface IBudgetCategoryCardLoaderStyledProps {}

export const BudgetCategoryCardLoaderStyled = styled.div<IBudgetCategoryCardLoaderStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  border: 1px solid ${(props) => props.theme.colors.content.border};
  border-radius: ${(props) => props.theme.typography.pxToRem(4)};

  padding: ${(props) => props.theme.typography.pxToRem(24)};
`
